import Store from '../../../../../Store/Store';
import Global from '../../../../../Services/Common/Global';
import { apiRequest } from '../../../../../Services/Common/ApiRequest';
import useSaveMutation from '../../../../../hooks/apis/useSaveMutaion';
import useSearchMutaion from '../../../../../hooks/apis/useSearchMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../../util';
import { Regulation_Schema } from './Regulation_Schema';
import { useQuery } from '@tanstack/react-query';

/**
 * Step00_Regulation 전용 Query/Mutation 훅
 * - 기본정보 저장은 RisCustomController.SaveRisCustomU1 사용
 * - 부서 조회는 GetDepLast(Utility) 사용
 */

export const useSave1 = (options = {}) => {
  return useSaveMutation(async (row) => {
    // 컨트롤러가 [FromBody] 단일 model을 받으므로 1건 객체로 전송
    const payload = mapRowsBySchema([row], Regulation_Schema.mapper.save1)?.[0];
    return apiRequest('post', Global.urls.RiskEvaluation.saveRisCustomU1, payload);
  }, options);
};

/**
 * 부서 조회 (GetDepLast) - 평가부서 셀렉트 옵션용
 * SafetyHealthInfoModal / RIS_BASIC_01F의 Search3와 동일 API
 */
export const useSearchDep = (successOptions = {}) => {
  return useSearchMutaion((_params) => {
    const context = {
      search: Store.getState()?.SearchInfo,
      userInfo: Store.getState()?.BaseInfo?.userInfo,
    };
    const params = mapParamsBySchema(
      Regulation_Schema.mapper.search1,
      context
    );
    return apiRequest('post', Global.urls.Utility.getDepLast, params);
  }, successOptions);
};

